import React from 'react';
import './styles.scss';

export default function Loading(): JSX.Element {
  return (
    <div className="loading">
      <i className="fa fa-5x fa-spin fa-spinner" />
    </div>
  );
}
